import { render, staticRenderFns } from "./select-image-from-activity-modal.vue?vue&type=template&id=5487ccda&scoped=true"
import script from "./select-image-from-activity-modal.vue?vue&type=script&lang=js"
export * from "./select-image-from-activity-modal.vue?vue&type=script&lang=js"
import style0 from "./select-image-from-activity-modal.vue?vue&type=style&index=0&id=5487ccda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5487ccda",
  null
  
)

export default component.exports